import React, { useState, useEffect } from 'react'
import {Circles, Oval} from "react-loader-spinner";
import VisDiv from './frontend_components/VisDiv';


const Loading = ({progressBar = false, seconds = 60, quotes=[]}) => {

return <div>
    <Spinner message = "...Loading..."/>
    <VisDiv rules={progressBar}>
        <ProgressBar progressBar={progressBar} seconds={seconds} quotes={quotes}/>
    </VisDiv>
    </div>
}

export default Loading


export const Spinner = ({message}) => {
    return (

        <div style={{marginBottom: "20px"}} className="flex-center-column">
            <Oval color={"#324d67"} secondaryColor={"#cecece"} height={66} width={66} />
            <div style={{marginTop: "-60px"}}>
                 <img src="/assets/logo192.png" width="48" height="48" alt="favicon-spinner" />
            </div>
           
        {/* <p>{message}</p> */}
        </div>
    );
}

export const ProgressBar = ({progressBar = false, seconds = 60, quotes = []}) => {
    const [progress, setProgress] = useState(0);
    
    useEffect(() => {
        const interval = setInterval(() => {
            setProgress(prevProgress => {
                if (prevProgress >= 99) {
                    clearInterval(interval);
                    return 99;
                }
                return prevProgress + (100 / (seconds * 10));
            });
        }, 100);
        
        return () => clearInterval(interval);
    }, [seconds]);
    
    return (
        <>
        <VisDiv rules={[progressBar]} style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center', 
            width: '100%',
            marginBottom: "10px"
        }}>
            <div style={{ 
                width: '100%', 
                maxWidth: '300px', 
                height: '10px', 
                backgroundColor: "#324d67",
                borderRadius: '5px',
                overflow: 'hidden',
                margin: '10px 0'
            }}>
                <div style={{ 
                    width: `${progress}%`, 
                    height: '100%', 
                    backgroundColor: "#cecece",
                    transition: 'width 0.1s ease-in-out'
                }}></div>
            </div>
            <div style={{ fontSize: '12px', color: "#324d67" }}>
                {Math.round(progress)}%
            </div>

        </VisDiv>

        </>
    );
}

